var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex justify-content-center align-items-center flex-column",staticStyle:{"background-color":"#efefef"}},[_vm._m(0),_c('div',{staticClass:"app-logo",class:_vm.logoClass})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"line-scale"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}]

export { render, staticRenderFns }